<div *ngIf="selectedGeneScore">
  <div class="row panel" id="gene-scores-panel">
    <div class="col-sm-9">
      <div id="select-help-wrapper">
        <div class="select-wrapper">
          <select
            class="form-control"
            [ngModel]="selectedGeneScore"
            (ngModelChange)="setSelectedGeneScore($event)"
            [title]="selectedGeneScore.desc"
            required>
            <option *ngFor="let geneScores of geneScoresArray" [ngValue]="geneScores">{{ geneScores.desc }}</option>
          </select>
          <span class="material-symbols-outlined select-dropdown-icon">arrow_drop_down</span>
        </div>
        <gpf-helper-modal
          style="height: 32px; margin-left: 4px"
          [style.visibility]="selectedGeneScore.help ? 'visible' : 'hidden'"
          [modalContent]="selectedGeneScore.help"
          [isMarkdown]="true"></gpf-helper-modal>
        <div *ngIf="isCategoricalHistogram(selectedGeneScore.histogram)">
          <button mat-icon-button [matMenuTriggerFor]="menu" id="view-menu-button">
            <span>Mode</span>
          </button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="switchCategoricalHistogramView('range selector')"
              [ngClass]="{ 'selected-view': selectedCategoricalHistogramView === 'range selector' }"
              >range selector
            </button>
            <button
              mat-menu-item
              (click)="switchCategoricalHistogramView('click selector')"
              [ngClass]="{ 'selected-view': selectedCategoricalHistogramView === 'click selector' }"
              >click selector
            </button>
            <button
              mat-menu-item
              (click)="switchCategoricalHistogramView('dropdown selector')"
              [ngClass]="{ 'selected-view': selectedCategoricalHistogramView === 'dropdown selector' }"
              >dropdown selector
            </button>
          </mat-menu>
        </div>
      </div>
      <div style="margin-top: 5px">
        <a class="download-link" href="{{ downloadUrl }}">Download</a>
      </div>
    </div>

    <div
      *ngIf="
        selectedGeneScore &&
        isCategoricalHistogram(selectedGeneScore.histogram) &&
        selectedCategoricalHistogramView === 'dropdown selector'
      "
      style="width: 100%">
      <gpf-categorical-values-dropdown
        [initialState]="categoricalValues"
        [histogram]="selectedGeneScore.histogram"
        (updateSelectedValues)="replaceCategoricalValues($event)"
        (emitValidationErrors)="setHistogramValidationErrors($event)"></gpf-categorical-values-dropdown>
    </div>

    <div *ngIf="selectedCategoricalHistogramView !== 'dropdown selector'" class="col-sm-9">
      <gpf-histogram
        *ngIf="selectedGeneScore && isNumberHistogram(selectedGeneScore.histogram)"
        [width]="650"
        [height]="145"
        [bins]="selectedGeneScore.histogram.bins"
        [bars]="selectedGeneScore.histogram.bars"
        [logScaleX]="selectedGeneScore.histogram.logScaleX"
        [logScaleY]="selectedGeneScore.histogram.logScaleY"
        [smallValuesDesc]="selectedGeneScore.histogram.smallValuesDesc"
        [largeValuesDesc]="selectedGeneScore.histogram.largeValuesDesc"
        [rangesCounts]="rangesCounts | async"
        (rangeStartChange)="setRangeStart($event)"
        (rangeEndChange)="setRangeEnd($event)"
        [rangeStart]="initialRangeStart"
        [rangeEnd]="initialRangeEnd"
        (emitValidationErrors)="setHistogramValidationErrors($event)">
      </gpf-histogram>
      <gpf-categorical-histogram
        *ngIf="
          selectedGeneScore &&
          isCategoricalHistogram(selectedGeneScore.histogram) &&
          selectedCategoricalHistogramView === 'click selector'
        "
        [width]="650"
        [height]="145"
        [histogram]="selectedGeneScore.histogram"
        [initialSelectedValueNames]="categoricalValues"
        [interactType]="selectedCategoricalHistogramView"
        (selectCategoricalValues)="replaceCategoricalValues($event)"
        (emitValidationErrors)="setHistogramValidationErrors($event)">
      </gpf-categorical-histogram>
      <gpf-categorical-histogram
        *ngIf="
          selectedGeneScore &&
          isCategoricalHistogram(selectedGeneScore.histogram) &&
          selectedCategoricalHistogramView === 'range selector'
        "
        [width]="650"
        [height]="145"
        [histogram]="selectedGeneScore.histogram"
        [initialSelectedValueNames]="categoricalValues"
        [interactType]="selectedCategoricalHistogramView"
        (selectCategoricalValues)="replaceCategoricalValues($event)"
        (emitValidationErrors)="setHistogramValidationErrors($event)">
      </gpf-categorical-histogram>
    </div>

    <div class="col-sm-9">
      <gpf-errors-alert [errors]="errors"></gpf-errors-alert>
    </div>
  </div>
</div>
<div *ngIf="!selectedGeneScore">
  <div class="form-block" style="display: contents">
    <div class="card">
      <ul ngbNav #nav="ngbNav" class="navbar bg-light nav-pills" style="justify-content: center">
        <li ngbNavItem>
          <span style="opacity: 75%"><i>No gene scores available</i></span>
        </li>
      </ul>
    </div>
  </div>
</div>
